import { getNanoId } from "./general.utils";
import { NANOID_LENGTH } from "../constants/general.constants";

export const MAX_TAG_LENGTH = 40;

// Any double underscores are replaced with a single underscore
// to avoid conflicts with the backend's advanced filtering logic
export const replaceDoubleUnderscoresToSingleUnderscore = (tag: string) => {
  return tag.replace(/__+/g, "_");
};

export const trimTagWithNanoIdSuffix = (tag: string, length: number) => {
  if (tag.length > length) {
    const nanoId = getNanoId();
    return replaceDoubleUnderscoresToSingleUnderscore(
      tag.substring(0, length - NANOID_LENGTH).concat(nanoId)
    );
  }
  return tag;
};
